<template>
  <div class="common-card">
    <div class="common-head">
      <div class="common-line"></div>
      <div class="common-title">{{value.title}}</div>
    </div>
    <div class="common-content">
      <div class="common-item cursor" v-for="(item, index) in value.contentList" :key="index"
           @click="change(item)">
        <span class="img" :class="{'small-height':!value.isCircle}">
          <img :class="{'rounded-circle': value.isCircle}"
               :src="item.img"
               alt="">
        </span>
        <span class="text" :title="item.name">{{item.name}}</span>
        <span class="sub-text" v-if="value.hasSubText">{{item.subText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonCard',
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          isCircle: false,
          hasSubText: true,
          title: '',
          contentList: []
        }
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped lang="scss">
  .common-card {
    width: 100%;
    height: 100%;

    .common-head {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 12px;

      .common-line {
        height: 16px;
        width: 3px;
        background: #208EFF;
        margin-right: 8px;
      }

      .common-title {
        color: #343A40;
        font-size: 16px;
        font-weight: bolder;
      }
    }

    .common-content {
      width: 100%;
      display: flex;
      height: calc(100% - 35px);
      padding: 0 10px;
      margin-top: 5px;

      .common-item {
        display: flex;
        width: 23%;
        flex-direction: column;
        align-items: center;
        font-size: 14px;

        .img {
          width: calc(100% - 20px);
          height: calc(100% - 20px);
        }

        .small-height {
          width: calc(100% - 20px);
          height: calc(100% - 20px);
        }

        img {
          width: 100%;
          height: 100%;
        }

        .text {
          width: 100%;
          margin-top: 5px;
          color: #343A40;
          white-space: nowrap;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .sub-text {
          color: #999999;
        }
      }
    }
  }
</style>
